import { render } from "./MainOverlayCopy.vue?vue&type=template&id=55b1324c&scoped=true"
import script from "./MainOverlayCopy.vue?vue&type=script&lang=js"
export * from "./MainOverlayCopy.vue?vue&type=script&lang=js"

import "./MainOverlayCopy.vue?vue&type=style&index=0&id=55b1324c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GB-Frontend/GB-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b1324c"]])

export default __exports__